/** Контент блока «Как организаторы используют preztimer» — `/use-cases/conferences` (макет Stitch). */

export type ConferencesOrganizerFeatureVisual = 'phone' | 'program' | 'messages';

export type ConferencesOrganizerFeature = {
  id: string;
  title: string;
  paragraphs: readonly string[];
  bullets: readonly string[];
  visual: ConferencesOrganizerFeatureVisual;
  /** На десктопе визуал слева (чётные блоки в макете). */
  visualFirst?: boolean;
};

export type ConferencesOrganizerPlacementItem = {
  title: string;
  description: string;
};

export type ConferencesOrganizerHybridCard = {
  title: string;
  description: string;
};

export type ConferencesOrganizerContent = {
  intro: {
    title: string;
    lead: string;
  };
  features: readonly ConferencesOrganizerFeature[];
  placement: {
    title: string;
    lead: string;
    items: readonly ConferencesOrganizerPlacementItem[];
  };
  hybrid: {
    title: string;
    paragraphs: readonly string[];
    cards: readonly ConferencesOrganizerHybridCard[];
  };
};

export const CONFERENCES_ORGANIZER_CONTENT: ConferencesOrganizerContent = {
  intro: {
    title: 'Как организаторы используют preztimer',
    lead:
      'От питч-сессий до корпоративных саммитов: одна комната на программу, панель управления для команды и экран таймера для спикера — в браузере, без установки.',
  },
  features: [
    {
      id: 'phone-control',
      title: 'Управляйте конференцией с телефона',
      paragraphs: [
        'Откройте панель управления в браузере на телефоне, планшете или ноутбуке. Запускайте и останавливайте таймер, переключайте таймеры в программе, корректируйте время в любой момент.',
        'Отдельное приложение не нужно: достаточно браузера и интернета — комната готова за минуту.',
      ],
      bullets: [
        'управление с телефона, планшета или ноутбука',
        'без кабелей и установки ПО',
        'Chrome, Safari, Firefox, Edge',
      ],
      visual: 'phone',
      visualFirst: true,
    },
    {
      id: 'program',
      title: 'Соберите программу выступлений за минуты',
      paragraphs: [
        'Создайте таймер под каждого спикера или сессию: название и длительность. Активный таймер переключаете вручную с панели — когда выходит следующий спикер.',
        'Отправьте спикерам ссылку на экран таймера — они видят отсчёт на своём устройстве и знают, когда выходить.',
      ],
      bullets: [
        'вся программа дня в одной комнате',
        'переключение таймеров во время мероприятия',
        'ссылка на экран таймера открывается на любом устройстве',
      ],
      visual: 'program',
    },
    {
      id: 'live-messages',
      title: 'Отправляйте подсказки спикеру, не прерывая выступление',
      paragraphs: [
        'Нужно попросить завершить блок или сменить темп? Сообщение с панели управления появляется на экране таймера — там, куда спикер и так смотрит.',
        'Без жестов из-за кулис: состояние комнаты обновляется в реальном времени на всех подключённых экранах.',
      ],
      bullets: [
        'сообщения на экране таймера',
        'появляются на экране сразу',
        'выступление и слайды не прерываются',
      ],
      visual: 'messages',
      visualFirst: true,
    },
  ],
  placement: {
    title: 'Разместите таймер там, где смотрит спикер',
    lead:
      'Откройте ссылку на экран таймера на любом дисплее — монитор у трибуны, телевизор в зале, планшет в бэкстейдже. Одна комната — несколько экранов с одним отсчётом.',
    items: [
      { title: 'Сцена', description: 'монитор перед спикером у трибуны' },
      { title: 'Трибуна', description: 'планшет или небольшой экран у микрофона' },
      { title: 'Задняя стена зала', description: 'крупный дисплей, виден со сцены' },
      { title: 'Бэкстейдж', description: 'следующий спикер видит, когда выходить' },
    ],
  },
  hybrid: {
    title: 'Очный формат, онлайн и несколько залов',
    paragraphs: [
      'Несколько треков или залов — отдельная комната на каждую сцену. У каждой свои ссылки на панель и экран таймера; команды работают независимо.',
      'Удалённые спикеры открывают экран таймера в браузере и видят тот же отсчёт, что в зале.',
    ],
    cards: [
      { title: 'Любое устройство', description: 'Нужен только браузер' },
      { title: 'Комната на зал', description: 'Независимое управление потоками' },
      { title: 'Удалённые спикеры', description: 'Один отсчёт на их экране' },
    ],
  },
};
